import React, { Fragment, Component } from "react";
import Carousel from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class Slider extends Component {
  constructor(props) {
    super(props);
    var values = props.values[0];
    this.state = {
      dots: values.isshowdots,
      delay: values.delay,
      sliderdata: [...values.sliderdata],
    };
  }
  render() {
    const settings = {
      dots: this.state.dots == "True" ? true : false,
      autoPlay: true,
      fade: true,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: this.state.delay * 1000,
      pauseOnHover: false,
      arrows: false,
    };
    return (
      <div>
        <Carousel {...settings}>
          {this.state.sliderdata.map((value, index) => (
            <a
              className="slider__link"
              href={value.LinkUrl ? value.LinkUrl : value.ProductLinkUrl}
              key={`figure${index}`}
            >
              <picture>
                {value.ImageUrl ? (
                  <source media="(min-width: 640px)" srcset={value.ImageUrl} />
                ) : null}

                {value.ImageMobileUrl ? (
                  <source srcset={value.ImageMobileUrl} />
                ) : null}

                <img
                  src={value.ImageUrl ? value.ImageUrl : ""}
                  alt="Slider Banner"
                  className="slider__image"
                />
              </picture>
              <h2 className="slider__text">{value.actionText}</h2>
            </a>
          ))}
        </Carousel>
      </div>
    );
  }
}
